import script from "./AppToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AppToast.vue?vue&type=script&setup=true&lang=js"

import "./AppToast.vue?vue&type=style&index=0&id=898ecd88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-898ecd88"]])

export default __exports__